const html = require("choo/html");
const PanelElement = require("../elements/panel.js");
const CarouselElement = require("../elements/carousel.js");
const CodePanel = require("../components/codepanel.js");
const VariablesPanel = require("../components/variablespanel.js");
const GlitchDropAreas = require("./glitchdropareas.js");

module.exports = function GlitchContext(state, emit) {
  const glitch = state.availableGlitches.find(
    (g) => g.id === state.selectedGlitchId
  );

  secondaryPanel = GlitchDropAreas(state, emit);

  return [VariablesPanel(state, emit), secondaryPanel];
};
